import React, { useContext } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { Theme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import { ArchivalCollection } from 'types';
import { GridActionButtonComponent } from 'components/grid/grid-types';

import {
  DownloadMetadaDialog,
  processRequestFileName,
} from 'components/dialog/aisuk-dialogs/download-metadata-dialog';
import { MetadataApiRoute, ReportTemplateType } from 'enums';
import { DialogContext } from 'components/dialog/dialog-context';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    navigationButton: {
      marginTop: theme.spacing(),
      alignSelf: 'baseline',
      width: '100%',
    },
  })
);

export function ArchivalCollectionDownload({
  item,
}: GridActionButtonComponent) {
  const classes = useStyles();
  const { open } = useContext(DialogContext);

  const archivalCollection = item as ArchivalCollection;

  const handleOpenDialog = () => {
    open({
      initialValues: {
        fileName: `f_${processRequestFileName(
          archivalCollection.evidenceNumber!
        )}.pdf`,
        data: archivalCollection,
        route: MetadataApiRoute.ARCHIVAL_COLLECTION,
        templateType: ReportTemplateType.ARCHIVAL_COLLECTION,
      },
      size: 'md',
      Content: (props) => (
        <DownloadMetadaDialog<ArchivalCollection> {...props} />
      ),
    });
  };

  return (
    <Button
      component="span"
      variant="outlined"
      color="primary"
      className={classes.navigationButton}
      onClick={handleOpenDialog}
    >
      Stáhnout metadata/popis
    </Button>
  );
}
